/*
*
* Version : 1.0.0
* 04/09/2016 - 10h18
*
*! Octave Web7 !*/

/**
 * angular-spinner version 0.8.1
 * License: MIT.
 * Copyright (C) 2013, 2014, 2015, 2016, Uri Shaked and contributors.
 * https://github.com/urish/angular-spinner
 */
(function (root) {
	'use strict';

	function factory(angular, Spinner) {

		return angular
			.module('module.spinner', [])

			.constant('SpinJSSpinner', Spinner)

			.provider('usSpinnerConfig', function () {
				var _config = {}, _themes = {}, _delay = 0;

				return {
					setDefaults: function (config) {
						_config = config || _config;
					},
					setTheme: function(name, config) {
						_themes[name] = config;
					},
					setDelay: function(delay) {
						_delay = delay;
					},
					$get: function () {
						return {
							config: _config,
							themes: _themes,
							delay: _delay
						};
					}
				};
			})

			.directive('usSpinner', ['SpinJSSpinner', 'usSpinnerConfig', function (SpinJSSpinner, usSpinnerConfig) {
				return {
					scope: true,
					link: function (scope, element, attr) {
						scope.spinner = null;

						function stopSpinner() {
							if (scope.spinner) {
								element.children().removeClass('in').addClass('out');
								setTimeout(function() {
									if (scope.spinner) {
										scope.spinner.stop();
									}
									element.children('.overlay').remove();
								}, scope.delay);
							}
						}

						scope.spin = function () {
							if (scope.spinner) {
								element.children().removeClass('out');
								scope.spinner.spin(element[0]);
								setTimeout(function() {
									element.children().addClass('in');
								});
							}
							$('<div class="overlay"/>').appendTo(element);
						};

						scope.stop = function () {
							stopSpinner();
						};

						var options = angular.extend(
							{},
							usSpinnerConfig.config,
							usSpinnerConfig.themes[attr.spinnerTheme]);
						scope.delay = usSpinnerConfig.delay;
						scope.spinner = new SpinJSSpinner(options);
						if (!scope.key && !attr.spinnerOn) {
							scope.spinner.spin(element[0]);
						}

						scope.$watch(attr.spinnerOn, function (spin) {
							if (spin) {
								scope.spin();
							} else {
								scope.stop();
							}
						});

						scope.$on('$destroy', function () {
							scope.stop();
							scope.spinner = null;
						});
					}
				};
			}]);
	}

  factory(root.angular, root.Spinner);

}(this));
